import React from 'react';
import styles from './SearchInput.module.css';
import SearchIcon from '../../Icons/SearchIcon';

/**
 * A sleek, custom inline SearchInput field.
 * Built-in search icon, standard styling wrappers, click-event propagation isolation, and dynamic change listeners.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.placeholder='Type to search...'] - Text placeholder displayed inside the search input trigger field.
 * @param {(val: string) => void} [props.onChange] - Callback fired when typing. Passes current search input text value.
 * @param {boolean} [props.autoFocus=true] - Focuses the field immediately upon mount.
 */
const SearchInput = ({ placeholder = 'Type to search...', onChange, autoFocus = true, ...rest }) => {
  const handleChange = (e) => onChange?.(e.target.value);
  const stopProp = (e) => e.stopPropagation();

  return (
    <div className={styles.wrapper}>
      <input
        type="text"
        className={styles.input}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onChange={handleChange}
        onClick={stopProp}
        onKeyDown={stopProp}
        {...rest}
      />
      <span className={styles.iconWrapper}>
        <SearchIcon />
      </span>
    </div>
  );
};

export default SearchInput;
